import { BellOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useAuth } from '@/lib/auth/use-auth';
import { useMyNotifications } from './hooks';
import { NotificationPanel } from './panel';

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { profile } = useAuth();
  const { data } = useMyNotifications(profile?.uid ?? null);
  const unread = data.filter((n) => !n.read).length;
  return (
    <>
      <button type="button" className="nav-icon-btn" title="Notifications" aria-label={unread ? `Notifications, ${unread} unread` : 'Notifications'} onClick={() => setOpen((o) => !o)}>
        <BellOutlined />{unread ? <span className="nav-badge">{unread}</span> : null}
      </button>
      <NotificationPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
